import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TrackedChangeFormatted = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 3.5C1.72386 3.5 1.5 3.72386 1.5 4C1.5 4.27614 1.72386 4.5 2 4.5H8C8.27614 4.5 8.5 4.27614 8.5 4C8.5 3.72386 8.27614 3.5 8 3.5H2ZM2 6.00012C1.72386 6.00012 1.5 6.22398 1.5 6.50012C1.5 6.77626 1.72386 7.00012 2 7.00012H6C6.27614 7.00012 6.5 6.77626 6.5 6.50012C6.5 6.22398 6.27614 6.00012 6 6.00012H2Z"
          fill={color}
        />
        <path
          d="M11.3161 9.96275C12.1294 11.3879 11.6505 13.1941 10.2667 14.0025C8.46789 15.0532 5.47284 14.9405 3.00293 13.0655C3.86029 13.0023 4.49047 12.8647 4.95625 12.6539C5.30332 12.4967 5.56835 12.295 5.76495 12.0473C5.96037 11.8011 6.06734 11.5357 6.13502 11.283C6.19142 11.0723 6.22491 10.8502 6.2542 10.6559C6.25868 10.6262 6.26306 10.5971 6.2674 10.5689C6.30217 10.3429 6.33781 10.1426 6.40124 9.94924C6.51848 9.5918 6.743 9.21754 7.33892 8.85928C8.86559 7.94147 10.4894 8.514 11.3161 9.96275Z"
          stroke={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1423 2.07495L14.2489 2.13766C14.7244 2.41738 14.8889 3.03412 14.6163 3.51518L11.3986 9.19462C11.5261 9.35404 11.6432 9.52638 11.7482 9.71049C11.8386 9.86885 11.9153 10.0314 11.9787 10.1967L15.4773 4.02166C16.0224 3.05953 15.6934 1.82605 14.7424 1.26661L14.6358 1.2039C13.6848 0.644463 12.472 0.970915 11.9269 1.93305L8.52968 7.92928C8.90757 7.88967 9.27789 7.92015 9.6302 8.01286L12.7879 2.43952C13.0604 1.95846 13.6668 1.79523 14.1423 2.07495Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default TrackedChangeFormatted
